import React, { ReactNode } from 'react';

import { useIntl } from 'react-intl';

import { CheckoutErrorCellContainer, Dot, ErrorText } from './styled';

interface ICheckoutErrorsModalProps {
  showDot?: boolean;
  checkoutErrorId: string;
  message?: string | ReactNode;
}

const CheckoutErrorCell: React.FC<ICheckoutErrorsModalProps> = ({
  showDot = false,
  checkoutErrorId,
  message,
}) => {
  const { formatMessage } = useIntl();

  return (
    <CheckoutErrorCellContainer $gridVariant={showDot}>
      {showDot && <Dot data-testId="checkout-error-dot" />}
      <ErrorText>{message || formatMessage({ id: checkoutErrorId })}</ErrorText>
    </CheckoutErrorCellContainer>
  );
};

export default CheckoutErrorCell;
